module.exports = __webpack_public_path__ + "img/9788946048195.e9d42a78.jpg";